import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseFormComponent } from 'src/app/base/components/base-form.component';
import { EventSharedService } from 'src/app/shared/services/event-shared.service';
import { MaskService } from 'src/app/shared/services/mask.service';
import { IndicadoresProjeto } from '../../models/indicadores-projeto.model';
import { IndicadoresPgService } from '../../services/indicadores-pg.service';
import { NavigationService } from '../../services/navigation.service';
import { AtualizacoesAudit } from '../../models/atualizacoes-audit';

@Component({
  selector: 'app-detalhe-pg-indicadores-config-edit',
  templateUrl: './detalhe-pg-indicadores-config-edit.component.html',
  styleUrls: ['./detalhe-pg-indicadores-config-edit.component.scss']
})
export class DetalhePgIndicadoresConfigEditComponent extends BaseFormComponent<IndicadoresProjeto> implements OnInit {

  pg_id: number;
  indicador: IndicadoresProjeto;
  type: string = '';
  list: any;
  listUsuario: any[];
  audit: AtualizacoesAudit;

  constructor(
    private myService: IndicadoresPgService,
    private router: Router,
    public activatedRoute: ActivatedRoute,
    public maskService: MaskService,
    private navigation: NavigationService
  ) {
    super(activatedRoute)
  }

  ngOnInit(): void {
    this.pg_id = this.activatedRoute.snapshot.params['idProjeto'];
    this.list = this.activatedRoute.snapshot.data['list'];
    this.listUsuario = this.activatedRoute.snapshot.data['listUsuario'];
    this.type = this.activatedRoute.snapshot.data['type'];
    this.initForm();

    this.loaded();
  }

  initForm() {
    this.form = new FormGroup({
      title: new FormControl('', [Validators.required]),
      description: new FormControl(''),
      description_goal: new FormControl(''),
      unit_id: new FormControl(null, [Validators.required]),
      goal: new FormControl(null, [Validators.required]),
      year_start: new FormControl(null, [Validators.required]),
      year_end: new FormControl(null, [Validators.required]),
      data_source: new FormControl(null),
      manager: new FormControl(null, [Validators.required]),
      adjunct: new FormControl(null),
      table_mod_id: new FormControl({ value: this.list?.select_table_mod_id ?? null, disabled: this.entity?.editSummed }, [Validators.required]),
      numerator_label: new FormControl(null, [Validators.required]),
      denominator_label: new FormControl(null, [Validators.required]),
      period_mod_id: new FormControl({ value: this.list?.select_period_mod_id ?? null, disabled: this.entity?.editSummed }, [Validators.required]),
      month1: new FormControl(null, this.list?.month1_enable ? Validators.required : []),
      month2: new FormControl(null, this.list?.month2_enable ? Validators.required : []),
      polarity: new FormControl({ value: this.list?.select_polarity ?? null, disabled: this.entity?.editSummed }, [Validators.required]),
      accum: new FormControl({ value: this.list?.select_accum ?? null, disabled: this.entity?.editSummed }, [Validators.required]),
      decimal_places: new FormControl({ value: "0", disabled: this.entity?.editSummed }, [Validators.required]),
      accum_show: new FormControl(null, [Validators.required]),
      accum_table: new FormControl(null, [Validators.required]),
      status_ok: new FormControl(null, this.entity ? Validators.required : []),
      status_warn: new FormControl(null, this.entity ? Validators.required : []),
      status_alert: new FormControl(null, this.entity ? Validators.required : []),
      level_mon_id: new FormControl(null, this.list?.level_mon_id_enable ? Validators.required : []),
      disabled: new FormControl(null, this.entity ? Validators.required : []),
    });

    if (this.entity) {
      this.form.patchValue(this.entity);

      if (this.entity?.readonly) {
        this.form.disable();
      }

      this.audit = {
        pg_ind_id: this.entity.id
      };
    }

    this.tableModRefresh(null, this.entity?.table_mod_id ?? this.list?.select_table_mod_id);
    this.accumTableChange();
    this.accumChange();
  }

  voltar() {
    if (this.entity?.id) {
      this.navigation.replace(['projetos', this.type ?? 'agregador', 'indicadores', this.entity?.id]);
    } else if (this.type) {
      this.navigation.replace(['projetos', this.type, this.pg_id, 'indicadores']);
    } else {
      this.navigation.replace(['projetos', 'agregador', this.pg_id, 'detalhe', 'indicadores']);
    }
  }

  getDataCreate(): IndicadoresProjeto {
    let data: IndicadoresProjeto;
    data = Object.assign({}, data, this.form.value);
    data.pg_id = this.entity?.pg_id ? this.entity?.pg_id : this.pg_id;
    return data;
  }

  salvar(): void {
    if (this.form.valid) {
      this.loading();
      if (this.entity?.id) {
        this.addSub(
          this.myService.update(this.getDataCreate(), this.entity?.id).subscribe({
            next: (res) => {
              this.msgSuccess('Indicador alterado com sucesso!');
              EventSharedService.get('auditRefresh').emit();
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      } else {
        this.addSub(
          this.myService.create(this.getDataCreate()).subscribe({
            next: (res) => {
              this.confirmation().subscribe(() => {
                this.navigation.replace(['projetos', this.type ?? 'agregador', 'indicadores', res.id]);
              })
              this.loaded();
            },
            error: (error) => {
              this.msgError(error?.error?.message);
              this.loaded();
            },
          })
        );
      }
    }
    else {
      this.markAsDirty();
    }
  }

  dataMask(event, field) {
    const inputValue = event.target.value;
    const sanitizedValue = inputValue.replace(/[^0-9/]/g, '');
    this.form.get(field).setValue(sanitizedValue);
  }

  maskNumber(event, field) {
    let value = event.target?.value.replace(/\D/i, '');
    this.form.get(field).setValue(value);
  }

  tableModRefresh(event, value_table_mod_id = null) {
    const value = value_table_mod_id ? value_table_mod_id : event?.id;
    const validators = value == 2 ? [Validators.required] : [];
    this.form.get('numerator_label').setValidators(validators);
    this.form.get('denominator_label').setValidators(validators);
    this.form.get('numerator_label').updateValueAndValidity();
    this.form.get('denominator_label').updateValueAndValidity();
    if ((value_table_mod_id === null && event?.id != 2)) {
      this.form.get('numerator_label').setValue(null);
      this.form.get('denominator_label').setValue(null);
    }
  }

  formatarMedidaFisica(field: string, decimalPlacesValue = 2) {
    let formValue = this.form.get(field)?.value;
    let value = this.maskService.formatarMedidaFisica(formValue, decimalPlacesValue);
    this.form.get(field).setValue(value);
  }

  accumChange() {
    let value = this.form.get('accum')?.value;
    if (value === '0') {
      this.form.get('accum_show').enable();
      this.form.get('accum_table').enable();
    } else if (value === '1') {
      this.form.get('accum_show').setValue('0');
      this.form.get('accum_table').setValue('0');
      this.form.get('accum_show').disable();
      this.form.get('accum_table').disable();
    }
  }

  accumTableChange() {
    let value = this.form.get('accum_table')?.value;
    if (value === '1') {
      this.form.get('accum_show').setValue('0');
      this.form.get('accum_show').disable();
    } else {
      this.form.get('accum_show').enable();
    }
  }

  confirmExcluir() {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir();
      }
    });
  }

  excluir() {
    this.loading();
    this.myService.delete(this.entity?.id).subscribe({
      next: (res) => {
        this.loaded();
        this.confirmation().subscribe(() => {
          if (this.type) {
            this.router.navigate(['projetos', this.type, this.entity?.pg_id, 'indicadores']);
          } else {
            this.router.navigate(['projetos', 'agregador', this.entity?.pg_id, 'detalhe', 'indicadores']);
          }
        });
      },
      error: (error) => {
        this.msgError(error.error?.message);
        this.loaded();
      }
    });
  }

  decimalChange(){
    this.formatarMedidaFisica('goal', this.form.get('decimal_places').value)
  }
}
